"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SharedMethods;
(function (SharedMethods) {
    SharedMethods["UNHANDLED_METHOD"] = "unhandled_method";
    SharedMethods["NODE_OPEN_TUNNEL"] = "node_open_tunnel";
    SharedMethods["NODE_CLOSE_TUNNEL"] = "node_close_tunnel";
})(SharedMethods = exports.SharedMethods || (exports.SharedMethods = {}));
var ServerExecutedMethods;
(function (ServerExecutedMethods) {
    ServerExecutedMethods["CLIENTS_LIST"] = "clients_list";
    ServerExecutedMethods["SUBSCRIBE_NODE_EVENT"] = "subscribe_node_event";
    ServerExecutedMethods["GET_PORT_FORWARDING_RULES"] = "get_port_forwarding_rules";
    ServerExecutedMethods["DELETE_PORT_FORWARDING_RULE"] = "delete_port_forwarding_rule";
    ServerExecutedMethods["NEW_PORT_FORWARDING_RULE"] = "new_port_forwarding_rule";
    ServerExecutedMethods["SET_PORT_FORWARDING_RULE_ENABLED"] = "set_port_rule_enabled";
    ServerExecutedMethods["GET_DEFINED_SOFTWARE"] = "get_defined_software";
    ServerExecutedMethods["DELETE_DEFINED_SOFTWARE"] = "delete_defined_software";
    ServerExecutedMethods["SAVE_DEFINED_SOFTWARE"] = "save_defined_software";
    ServerExecutedMethods["GET_BANNED_NODES"] = "get_banned_nodes";
    ServerExecutedMethods["UNBAN_NODE"] = "unban_node";
})(ServerExecutedMethods = exports.ServerExecutedMethods || (exports.ServerExecutedMethods = {}));
var ServerNotifications;
(function (ServerNotifications) {
    ServerNotifications["WRITE_NODE_LOG_ENTRY"] = "write_node_log_entry";
    ServerNotifications["GET_SERVER_STATS"] = "get_server_stats";
})(ServerNotifications = exports.ServerNotifications || (exports.ServerNotifications = {}));
var ClientNotifications;
(function (ClientNotifications) {
    ClientNotifications["CONNECTION_ACK"] = "connection_ack";
    ClientNotifications["NODE_INFO_UPDATED"] = "node_info_updated";
    ClientNotifications["NODE_INFO_ONLINE"] = "node_info_online";
    ClientNotifications["NODE_INFO_OFFLINE"] = "node_info_offline";
    ClientNotifications["DOWNLOAD_FILE_FROM_BUCKET"] = "download_file_from_bucket";
    ClientNotifications["SETTINGS_CHANGED"] = "settings_changed";
    ClientNotifications["PORT_FORWARDING_RULES_CHANGED"] = "port_rules_changed";
})(ClientNotifications = exports.ClientNotifications || (exports.ClientNotifications = {}));
var ClientExecutedMethods;
(function (ClientExecutedMethods) {
    ClientExecutedMethods["GET_NODE_SOFTWARE"] = "get_node_software";
    ClientExecutedMethods["UPDATE_NODE_SOFTWARE"] = "update_node_software";
    ClientExecutedMethods["UPDATE_NODE_CONFIG"] = "update_node_config";
    ClientExecutedMethods["RESTART_NODE_SOFTWARE"] = "restart_node_software";
    ClientExecutedMethods["TAKE_DESKTOP_SCREENSHOT"] = "desktop_screenshot";
    ClientExecutedMethods["LIST_NODE_LOGS"] = "list_node_logs";
    ClientExecutedMethods["GET_NODE_LOG"] = "get_node_log";
    ClientExecutedMethods["PING"] = "ping";
    ClientExecutedMethods["GET_SOFTWARE_CONFIG"] = "get_software_config";
})(ClientExecutedMethods = exports.ClientExecutedMethods || (exports.ClientExecutedMethods = {}));
const DMSMethod = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, SharedMethods), ServerExecutedMethods), ServerNotifications), ClientNotifications), ClientExecutedMethods);
exports.default = DMSMethod;
//# sourceMappingURL=DMSMethod.js.map